import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for managing campaign member exclusion records.
 * F-022: Member Exclusion Lists - CRUD operations for exclusion audit trail.
 */
@Injectable({
    providedIn: 'root'
})
export class CampaignMemberExclusionService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignMemberExclusions')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-user-minus';
    }
}
